import styled, { css } from 'styled-components';
import { Checkbox, Input, Select } from 'antd';

export const ScriptSectionWrapper = styled.div`
  margin-top: 12px;
  background: #f5fbfc;
  padding: 16px 8px;
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const ItemFieldsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0 16px;
  align-items: end;
  margin-bottom: 8px;
`;

export const StyledSharingButton = styled.button`
  position: relative;
  font-family: 'Mulish', sans-serif !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.08px;
  min-width: 183px;
  border: 2px solid transparent;
  height: 51px;
  padding: 0px 12px;
  border-radius: 8px;
  background: #d0e3e7;
  color: #7da1a9;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    border: 2px solid #afccd2;
    background: transparent;
    color: #afccd2;
  }

  @media (max-width: 768px) {
    min-width: unset;
    width: fit-content;
  }
`;

const inputStyles = css`
  font-family: 'Mulish', sans-serif !important;
  min-height: 51px !important;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0px 3.45px 13.79px 0px rgba(0, 0, 0, 0.07);
  color: #062e3a !important;
`;

export const StyledInput = styled(Input)`
  ${inputStyles}
  &::placeholder {
    font-family: 'Mulish', sans-serif;
    font-weight: 400;
    color: #afccd2 !important;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selection-placeholder {
    font-family: 'Mulish', sans-serif;
    font-weight: 400;
    color: #afccd2 !important;
    font-size: 16px;
    line-height: 20px;
  }

  .ant-select-selection-search > input {
    color: #062e3a !important;
    font-size: 16px !important;
    padding: 0 16px;
  }
  .ant-select-selector {
    ${inputStyles}
    border-color:  transparent !important;

    &:hover {
      border-color: #9f6bff !important;
    }
  }
  .ant-select-selection-item {
    align-items: center !important;
    height: 44px !important;
  }
  .ant-select-selection-item-remove {
    font-size: 18px !important;
    color: #afccd2 !important;
  }
`;

export const SelectOptionsUser = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.08px;
  text-transform: capitalize;
  color: #3d6c77;
  & .tag-email {
    font-size: 12px;
    font-weight: 500;
    line-height: 15.06px;
    text-transform: none;
    color: #7da1a9;
  }
`;

export const CustomTag = styled.div`
  display: flex;
  align-items: center;
  margin: 2px 5px 2px 0;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  height: 51px;
  box-shadow: 0px 3.81px 15.25px 0px #00000012;

  & .btn-close:hover {
    cursor: pointer;
  }
`;

export const SharingList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background-color: transparent !important;
    border-color: #7da1a9 !important;
    color: #7da1a9 !important;
    &::after {
      border-color: #7da1a9 !important;
    }
  }
`;
